import React /*, { ReactNode }*/ from 'react';
import { Box, Stack, Typography, Container } from '@mui/material';
//import { ReactComponent as AISVG } from '../../assets/ai_star.svg';
//import { showProfile } from '../../features/dialogSlice';
import { Patients } from '../patient/Patients';

interface AnalyticUsersProps{
    aiSummaryRecord: any
}


export const AnalyticUsers: React.FC<AnalyticUsersProps> = ({aiSummaryRecord}) => {
    const analyticUsers = aiSummaryRecord.type === "numeric" ? aiSummaryRecord.analytics.users : (aiSummaryRecord.type === "text" ? aiSummaryRecord.analytics : undefined)
    if( !analyticUsers)
        return null


    //return (<Stack sx={{ width: '100%', backgroundColor: 'black' }} alignItems="center" direction="column"/>)


    //return (<Box sx={{width: '100%', flexGrow:5, backgroundColor: 'yellow'}}>trecfghtyhrv</Box>)
    return (
        <Box
            sx={{ display: 'flex',
                overflow: 'auto',
                width: '100%',
                //height: { xs: '80svh', sm: '80svh', md: '90vh' },
            }}
        >
            <Container>
                <Stack sx={{ width: '100%' , flexGrow: 6}} alignItems="center" direction="column">
                    <Stack alignItems="center" direction="row" justifyContent="center" sx={{ mt: 1, mb: 2, width: '100%', position: 'relative' }}>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            {aiSummaryRecord.formattedVariable}
                        </Typography>
                    </Stack>
                    <Patients patientsData={analyticUsers} pageCap={10} align={"center"} />
                </Stack>
            </Container>
        </Box>
    )
}


